<template>
  <div class="stages">
    <v-tooltip
      top
      max-width="160"
      content-class="v-tooltip__custom-content"
      v-for="(stage, index) in orderStages"
      :key="`${stage.orderStatus}-${index}`"
    >
      <Stage slot="activator" iconSize="28" :status="stage.status" :hiddenTail="stage.hiddenTail" />
      <div>
        <div>{{ $t(stage.tooltip) }}: {{ $t(stage.callbackStatus) }}</div>
        <div v-if="stage.time" class="stages__tool-tip__time">{{ stage.time }}</div>
      </div>
    </v-tooltip>
  </div>
</template>

<i18n>
  {
    "en": {
      "stages": {
        "succeed": "Succeed",
        "failed": "failed",
        "not_yet": "Not yet"
      }
    },
    "vi": {
      "stages": {
        "succeed": "Thành công",
        "failed": "Thất bại",
        "not_yet": "Chưa"
      }
    }
  }
</i18n>

<script>
import Stage from './Stage'
import { ORDER_STATUS } from '@/mixins/constants'

const ORDER_STAGES = {
  [ORDER_STATUS.ACCEPTED]: {
    tooltip: 'order_status.ACCEPTED',
    callbackStatus: 'stages.not_yet',
    status: undefined
  },
  [ORDER_STATUS.IN_PROCESS]: {
    tooltip: 'order_status.IN_PROCESS',
    callbackStatus: 'stages.not_yet',
    status: undefined
  },
  [ORDER_STATUS.COMPLETED]: {
    tooltip: 'order_status.COMPLETED',
    callbackStatus: 'stages.not_yet',
    status: undefined,
    hiddenTail: true
  }
}

export default {
  name: 'Stages',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Stage
  },
  computed: {
    orderStages() {
      const result = { ...ORDER_STAGES }

      this.data.forEach((callback) => {
        if (callback && ORDER_STAGES[callback.order_status]) {
          const status = callback.response_code === 200

          result[callback.order_status] = {
            ...ORDER_STAGES[callback.order_status],
            status,
            orderStatus: callback.order_status,
            callbackStatus: status ? 'stages.succeed' : 'stages.failed',
            time:
              callback.callback_time &&
              this.$moment.unix(callback.callback_time).format('HH:mm DD/MM/YYYY')
          }
        }
      })

      return Object.values(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.stages {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;

  .v-tooltip:not(:last-child) {
    margin-right: 12px;
  }
}

.stages__tool-tip__time {
  font-size: 12px;
}
</style>
